import { serviceDirectoryApiClient } from '@/services/service-directory';

export interface ArticleForm {
  id: string;
  title: string;
  sourceUrl: string;
  content: string;
  imageUrl: string;
  author: string;
  summary: string;
  publishedAt: string;
  tags: string[];
  isFeatured: boolean;
  isActive: boolean;
  isPublic: boolean;
  isGlobal: boolean;
}

class RankItems {
  fetchRankEntities = async (rankItemId: string) => {
    const response = await serviceDirectoryApiClient.get(`rank-items/${rankItemId}/entities`);
    return response.data;
  };
}

export const RankItemsInstance = new RankItems();
